import React, { useEffect, useState } from "react";
import {
  Input,
  InputNumber,
  Select,
  TimePicker,
  Form,
  Col,
  Row,
  Button,
  Collapse,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import { odata } from "./Helper";
import RequestHandler from "../../util/RequestHandler";

const { RangePicker } = TimePicker;

const periodOptions = [
  { value: "Day", label: "Gün" },
  { value: "Week", label: "Hafta" },
  { value: "Month", label: "Ay" },
];

const endTypeOptions = [
  { value: "Never", label: "Sonlanmasın" },
  { value: "AfterOccurrence", label: "Tekrar sonrası" },
  { value: "OnDate", label: "Belirli tarihte" },
];

const toDuration = (time) => {
  const t = moment(time);
  return `duration'PT${t.hours()}H${t.minutes()}M'`;
};

function SweepRuleListFilter(props) {
  const [form] = Form.useForm();
  const [banks, setBanks] = useState([]);

  useEffect(() => {
    RequestHandler.get(`/Bank?$select=id,name&$orderby=name`).then((response) => {
      if (response && Array.isArray(response.value)) {
        setBanks(response.value);
      }
    });
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFinish = (values) => {
    const conditions = [];

    if (values.name) {
      conditions.push(odata.contains("name", values.name));
    }

    if (values.receiverBankName) {
      conditions.push(odata.contains("receiverBankName", values.receiverBankName));
    }

    if (values.receiverIban) {
      conditions.push(odata.contains("receiverIban", values.receiverIban));
    }

    if (values.executionTimeRange && values.executionTimeRange.length === 2) {
      const [start, end] = values.executionTimeRange;
      if (start) {
        conditions.push(`executionTime ge ${toDuration(start)}`);
      }
      if (end) {
        conditions.push(`executionTime le ${toDuration(end)}`);
      }
    }

    if (values.frequencyPeriod) {
      conditions.push(`frequencyPeriod eq '${values.frequencyPeriod}'`);
    }

    if (values.frequencyInterval || values.frequencyInterval === 0) {
      conditions.push(`frequencyInterval eq ${values.frequencyInterval}`);
    }

    if (values.endType) {
      conditions.push(`endType eq '${values.endType}'`);
    }

    const query = conditions.length !== 0 ? conditions.join(" and ") : "";

    if (props.onFinishFilter) props.onFinishFilter(query, values);
  };

  const clearFilter = () => {
    form.resetFields();
    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="sweepRuleFilter"
              form={form}
              initialValues={{ remember: true }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }} gutter={12}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Tanım Adı" name="name">
                    <Input placeholder="Tanım adı giriniz" allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Alıcı Banka" name="receiverBankName">
                    <Select
                      placeholder="Alıcı banka seçiniz"
                      allowClear
                      showSearch
                      optionFilterProp="children"
                    >
                      {banks.map((item) => (
                        <Select.Option key={item.id} value={item.name}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Alıcı Hesap" name="receiverIban">
                    <Input placeholder="IBAN giriniz" allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Gerçekleşme Saati" name="executionTimeRange">
                    <RangePicker
                      format="HH:mm"
                      style={{ width: "100%" }}
                      placeholder={["Başlangıç", "Bitiş"]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Tekrar Periyodu" name="frequencyPeriod">
                    <Select
                      placeholder="Periyot seçiniz"
                      allowClear
                      options={periodOptions}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Tekrar Aralığı" name="frequencyInterval">
                    <InputNumber
                      min={0}
                      style={{ width: "100%" }}
                      placeholder="Aralık giriniz"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Sonlanma" name="endType">
                    <Select
                      placeholder="Sonlanma seçiniz"
                      allowClear
                      options={endTypeOptions}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
}

export default SweepRuleListFilter;
